class editSmsTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');

        this.key = 'view-template';
        this.title = this.translate.instant('messages.workflows.sms-template-list.edit-template.title');
        this.level = 'row';
    }

    action(payload, store) {
        return this.state.go('app.messages.sms.templates.edit', {id: payload.row.id, store: store});
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('editSmsTemplate', [
        '$injector',
        $injector => new editSmsTemplate($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/sms-template-list/edit-template.js